/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable import/no-named-as-default */
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import {
  TouchableOpacity,
  View,
  ActivityIndicator,
  Linking,
  Platform,
  Alert,
  BackHandler,
  StyleSheet,
  RefreshControl,
  Modal,
  Animated,
  LayoutAnimation,
} from "react-native";
import { getItem, setItem, removeItem } from "@lib/storage";
import useFocusAndAppState from "@hooks/useFocusAndAppState";
import useLocationHook, {
  useCachedLocation,
} from "@components/common/LocationHook";
import t from "@constants/localization";
import colors from "@constants/color";
import * as Sentry from "@sentry/react-native";
import Delivery from "@assets/svg/ShopPerformance/TickCircle";
import Pending from "@assets/svg/RRD/pending";
import Rescheduled from "@assets/svg/RRD/rescheduled";
import RtoIcon from "@assets/svg/RRD/Rto";
import Text from "@components/CustomText";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { debounce } from "lodash";
import FiltersIcon from "@assets/svg/Wallet/Filter";
import {
  cancelRto,
  createSarvCallAPI,
  getDeliveryTasks,
  getPickupItemsListV2,
  markTouchpointPickedUpByCpdb,
  markTouchpointPickedUpByCpdbV2,
  unmarkPickupByCpdbV2,
  pickTpV3,
} from "@services/api";
import {
  buildItemsFromState,
  buildPickTpItemsPayload,
  getPickTpErrorMessage,
} from "./components/pickTpHelpers";
import { useSelector } from "react-redux";
// Plotline widget removed
import HeaderWithSearch from "@components/SearchHeader/HeaderWithSearch";
import { ScrollView } from "react-native-gesture-handler";
import { width } from "@constants/metrics";
import analytics from "@services/analytics";
import { MY_TASK_EVENTS } from "@constants/analyticsEventsCT.js";
import DeliveryCard from "./components/DeliveryCard";
import BagsItemsModal from "./components/BagsItemsModal";
import PickupCard from "./components/PickupCard";
import DelayTag from "./components/DelayTag";
import FilterModal from "./components/FilterModal";
import EmptyList from "./components/EmptyList";
import ContactModal from "./OrdersMapView/ContactModal";
import CallOptionsModal from "./components/CallOptionsModal";
import { contactAllowedCardTypes } from "./OrdersMapView/constants";
import SearchField from "./components/SearchField";
import SarvCallModal from "./components/SarvCallModal";
import PickupConfirmationModal from "./components/PickupConfirmationModal";
import MissingItemsConfirmModal from "./components/MissingItemsConfirmModal";
import PickTpItemsModal from "./components/PickTpItemsModal";
import PickTpShipmentsModal from "./components/PickTpShipmentsModal";

const PATH = "screens/MyTask";

const pageEnum = {
  PENDING: "pending",
  ESCALATED: "escalated",
  DELIVERY: "delivery",
  RTO: "rto",
  RESCHEDULED: "rescheduled",
};

const SARV_MODE = {
  UNIDIRECTIONAL: "UNIDIRECTIONAL",
  TWO_WAY_CALL: "TWO_WAY_CALL",
  DISABLED: "DISABLED",
};

function MyTask({ route }) {
  const initialFilter = { routes: [], dbs: [] };
  const navigation = useNavigation();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(pageEnum.PENDING);
  const [listData, setListData] = useState([]);
  const [pastListData, setPastListData] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(initialFilter);
  // The filter last applied with Save. selectedFilter is the popup's draft;
  // closing without Save (✕, backdrop, Android back) restores this, so an
  // unsaved pick never shows as selected or reaches a later fetch.
  const appliedFilterRef = useRef(initialFilter);
  const [bagsInfo, setBagsInfo] = useState({
    bags_disabled: false,
    cx_packing_enabled: false,
    source: "CPDB_BAGS_TASK_PAGE",
    type: "CRATE",
    date: new Date().toISOString().split("T")[0],
  });
  const [amountCollected, setAmountCollected] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [contactOption, setContactOption] = useState(null);
  const [showCallOptionsModal, setShowCallOptionsModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [callModalMode, setCallModalMode] = useState("DEFAULT");
  const [showBagsLargeItemsModal, setShowBagsLargeItemsModal] = useState(false);
  const isRescheduledCp = useRef(false);
  const [selectedCategory, setSelectedCategory] = useState("routes");
  const [taskActionConfig, setTaskActionConfig] = useState({});
  const [filterV2, setFilterV2] = useState({});
  const [filterV2Meta, setFilterV2Meta] = useState({});
  const [showSarvModal, setShowSarvModal] = useState(false);
  const [sarvMode, setSarvMode] = useState(SARV_MODE.DISABLED);
  const [sarvCliNumber, setSarvCliNumber] = useState("");
  const [contactOpts, setContactOpts] = useState([]);
  const [pickupConfirmationV2Enabled, setPickupConfirmationV2Enabled] =
    useState(false);
  const [showPickupConfirmationModal, setShowPickupConfirmationModal] =
    useState(false);
  const [pickupConfirmationItems, setPickupConfirmationItems] = useState([]);
  const [pickupConfirmationMeta, setPickupConfirmationMeta] = useState(null);
  const [pickupItemsLoading, setPickupItemsLoading] = useState(false);
  const [pickupSubmitLoading, setPickupSubmitLoading] = useState(false);
  const [showMissingConfirm, setShowMissingConfirm] = useState(false);
  // Dark-store rack-based picking (pickup_scan_v3_enabled). See
  // docs/cp-features/darkstore-cmo-receiving-db-picking.md §6 in
  // citymall-services. `carriedShipments` holds whatever the DB had already
  // scanned in PickTpShipmentsModal before falling back to the item sheet
  // ("कुछ नहीं मिला?"). Photos now ride per line in PickTpItemsModal
  // (decision 9), not on a TP-level confirm step.
  const [pickupScanV3Enabled, setPickupScanV3Enabled] = useState(false);
  const [showPickTpModal, setShowPickTpModal] = useState(false);
  const [pickTpMeta, setPickTpMeta] = useState(null);
  const [carriedShipments, setCarriedShipments] = useState([]);
  // decision 9: per-line found / not found / damaged + per-reason photos for
  // dark-store CPs. Keyed by order_item_id; see pickTpHelpers.
  const [pickTpItemsState, setPickTpItemsState] = useState({});

  const textInputRef = useRef(null);
  const handleOptionPress = (item) => {
    setSelectedFilter((prev) => ({ ...prev, [selectedCategory]: item }));
  };
  const getSelectedFilters = () => {
    return selectedFilter[selectedCategory] || {};
  };
  const clearFilters = () => {
    setSelectedFilter(initialFilter);
    setSelectedCategory("routes");
    analytics.trackEvent(MY_TASK_EVENTS.CLEAR_FILTER);
  };

  const cp_db_id = useSelector(({ auth }) => auth?.user?.cp_db_id);
  // Capture path, mounted here on purpose. MyTasks is the hub every delivery
  // starts from, so taking the fix here seeds state.location.lastFix while the
  // DB is still choosing a customer — by the time they reach CustomerOrderView
  // / NewOTPVerification (both cache-only, never wake GPS) there is a real,
  // recent fix to stamp. Mounting the hook also runs the ACCESS_FINE_LOCATION
  // permission check. See docs/flows/location-capture-and-transmission.md.
  const getCurrentLocation = useLocationHook();
  // Read side comes from the session-scoped slice, NOT the persisted
  // auth.coords: that one rehydrates with the previous session's fix on a cold
  // start, which would have this screen request tasks around yesterday's
  // position. This screen seeds the slice itself on focus (below), so it is the
  // freshest source available at request time.
  const getCachedLocation = useCachedLocation();

  useFocusAndAppState(
    () => {},
    () => {
      if (isRescheduledCp.current) {
        getItem("CARD_ACTION").then((val) => {
          if (!val) return;
          setShowCallOptionsModal(true);
          setContactOption(null);
          setShowSarvModal(false);
          removeItem("CARD_ACTION");
        });
      }
    },
  );

  useEffect(() => {
    const backHandler = () => {
      if (isSearchEnabled) {
        onSearchInputChange("");
        setIsSearchEnabled((prev) => !prev);
        return true;
      }
      return false;
    };

    const subscription = BackHandler.addEventListener(
      "hardwareBackPress",
      backHandler,
    );

    return () => {
      subscription.remove();
    };
  }, [isSearchEnabled, onSearchInputChange]);

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, [currentPage]),
  );

  // Re-seed the location store on every focus, not just mount: the DB pops
  // back here after each delivery (navigation.pop(2)) while this screen stays
  // mounted, so mount-only would capture once per session. The `5` is the
  // hook's cache tolerance in MINUTES, not a request timeout — returning within
  // that window reuses the existing fix instead of re-waking GPS, so a DB
  // working through a dense cluster of touchpoints triggers far fewer captures.
  useFocusEffect(
    useCallback(() => {
      getCurrentLocation(5);
    }, []),
  );

  const filterPayload = useMemo(() => {
    const res = Object.keys(selectedFilter).reduce((acc, key) => {
      if (["routes", "dbs"].includes(key))
        acc[key] = selectedFilter[key]?.key ? [selectedFilter[key]?.key] : [];
      else acc[key] = selectedFilter[key]?.key;

      return acc;
    }, {});
    return res;
  }, [selectedFilter]);

  const onRefresh = () => {
    setIsRefreshing(true);
    fetchData();
    setIsRefreshing(false);
  };

  const createSarvCall = async (payload) => {
    try {
      const response = await createSarvCallAPI(payload);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const createCall = useCallback(
    async (phone, cx_id, route_id, callmatic_mode) => {
      if (!phone) {
        console.error("createCall: No phone number provided");
        return;
      }

      // Per-touchpoint override stamped on each CX card by the backend
      // (touchpoint-level Callmatic); falls back to the response-level mode.
      const mode = callmatic_mode || sarvMode;

      await createSarvCall({
        cx_phone_number: phone,
        sarv_cli_number: sarvCliNumber,
        sarv_mode: mode,
        cx_id,
        route_id,
      });

      if (mode === SARV_MODE.DISABLED) {
        Linking.openURL(`tel:${phone}`);
      } else if (mode === SARV_MODE.UNIDIRECTIONAL) {
        Linking.openURL(`tel:${sarvCliNumber}`);
      } else if (mode === SARV_MODE.TWO_WAY_CALL) {
        setShowSarvModal(true);
      }
    },
    [sarvMode, sarvCliNumber],
  );
  const addBagsHandler = useCallback(
    ({
      order_ids,
      user_id,
      route_id,
      bags = [],
      user_name,
      route_name,
      db_name,
    }) => {
      if (!order_ids.length) {
        return;
      }
      navigation.navigate("SortingTasksPage", {
        orders_list: order_ids,
        spokeName: "",
        user_id,
        route_id,
        bags,
        user_name,
        route_name,
        db_name,
        ...bagsInfo,
      });
    },
    [bagsInfo],
  );

  const fetchData = async ({ searchTerm = "", isSearch = true } = {}) => {
    setIsLoading(true);
    try {
      // Projected back to exactly {latitude, longitude}: lastFix also carries
      // accuracy/source/updated_at, and `coords` is a server-facing shape.
      // Left `undefined` when there is no fix so the key stays absent from the
      // body, as it was when auth.coords was unset — not sent as explicit nulls.
      const { latitude, longitude } = getCachedLocation();
      const coords =
        latitude != null && longitude != null
          ? { latitude, longitude }
          : undefined;
      const payload = {
        searchTerm: isSearch ? searchTerm || searchText : "",
        filter: filterPayload,
        coords,
      };
      const { data } = await getDeliveryTasks(payload);
      isRescheduledCp.current = data?.isRescheduledCp || false;
      setSarvMode(data?.sarv_mode);
      setBagsInfo(data?.bags_info);
      setSarvCliNumber(data?.sarvCliNumber);
      setHeaderData(data?.tasks);
      setFilterV2(data?.filters_v2);
      setFilterV2Meta(data?.filters_v2_meta);
      setAmountCollected(data?.amount_collected_today);
      setTaskActionConfig(data?.task_action_config);
      setPickupConfirmationV2Enabled(
        Boolean(data?.pickup_confirmation_v2_enabled),
      );
      setPickupScanV3Enabled(Boolean(data?.pickup_scan_v3_enabled));
      setContactOpts(
        Array.isArray(data?.contact_btns) ? data?.contact_btns : ["DIALER"],
      );
      if (currentPage === pageEnum.PENDING) {
        setListData(data?.pending);
        setPastListData([]);
      } else if (currentPage === pageEnum.ESCALATED) {
        setListData(data?.escalated);
        setPastListData([]);
      } else if (currentPage === pageEnum.RESCHEDULED) {
        setListData(data?.rescheduled);
        setPastListData([]);
      } else if (currentPage === pageEnum.DELIVERY) {
        setListData(data?.deliveredToday);
        setPastListData(data?.deliveredPast);
      } else if (currentPage === pageEnum.RTO) {
        setListData(data?.rtoToday);
        setPastListData(data?.rtoPast);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const closePickupConfirmationModal = () => {
    setShowPickupConfirmationModal(false);
    setShowMissingConfirm(false);
    setPickupConfirmationItems([]);
    setPickupConfirmationMeta(null);
    setPickupItemsLoading(false);
    setPickupSubmitLoading(false);
    setCarriedShipments([]);
    setPickTpItemsState({});
  };

  const openPickupConfirmationModal = async (pickupData, parentItem) => {
    const orderIds =
      pickupData?.order_ids ||
      pickupData?.delivery_pending_order_ids ||
      [pickupData?.order_id].filter(Boolean);
    const cxUserId = parentItem?.user_id || pickupData?.user_id;
    const routeId = parentItem?.route_id || pickupData?.route_id;

    if (!orderIds.length || !cxUserId) {
      return;
    }

    setPickupConfirmationMeta({
      route_id: routeId,
      cx_user_id: cxUserId,
      order_ids: orderIds,
    });
    setShowPickupConfirmationModal(true);
    setPickupItemsLoading(true);

    try {
      const { data } = await getPickupItemsListV2({
        order_ids: orderIds,
        user_id: cxUserId,
      });
      setPickupConfirmationItems(
        Array.isArray(data?.items)
          ? data.items.map((item) => ({
              ...item,
              is_selected: false,
              selected_quantity: Number(item.expected_quantity) || 0,
            }))
          : [],
      );
    } catch {
      Alert.alert("Unable to load pickup items");
      closePickupConfirmationModal();
    } finally {
      setPickupItemsLoading(false);
    }
  };

  const closePickTpModal = () => {
    setShowPickTpModal(false);
    setPickTpMeta(null);
  };

  const handlePickTpSubmitSuccess = () => {
    closePickTpModal();
    onRefresh();
  };

  // "कुछ नहीं मिला? आइटम-वाइज़ पिकिंग पर जाएँ" — closes the racks-first sheet
  // and reopens the EXISTING item sheet (decision 5), carrying whatever the
  // DB had already scanned so pick-tp-v3 mode "ITEMS" can include it.
  const handlePickTpFallback = async (scannedShipments) => {
    const meta = pickTpMeta;
    closePickTpModal();
    setCarriedShipments(scannedShipments || []);
    if (!meta) {
      return;
    }
    await openPickupConfirmationModal(
      { order_ids: meta.order_ids, user_id: meta.cx_user_id },
      { route_id: meta.route_id, user_id: meta.cx_user_id },
    );
  };

  const onPickupQuantityChange = (orderItemId, nextQuantity) => {
    setPickupConfirmationItems((prev) =>
      prev.map((item) => {
        if (item.order_item_id !== orderItemId) {
          return item;
        }

        const expectedQuantity = Number(item.expected_quantity) || 0;
        const selectedQuantity = Math.max(
          0,
          Math.min(expectedQuantity, nextQuantity),
        );

        return {
          ...item,
          selected_quantity: selectedQuantity,
        };
      }),
    );
  };

  const onPickupSelectionChange = (orderItemId, isSelected) => {
    setPickupConfirmationItems((prev) =>
      prev.map((item) =>
        item.order_item_id === orderItemId
          ? {
              ...item,
              is_selected: Boolean(isSelected),
            }
          : item,
      ),
    );
  };

  const getMissingPickupItems = () =>
    pickupConfirmationItems
      .map((item) => {
        const expectedQuantity = Number(item.expected_quantity) || 0;
        const pickedQuantity = item.is_selected
          ? Number(item.selected_quantity) || 0
          : 0;
        return {
          order_item_id: item.order_item_id,
          order_id: item.order_id,
          title: item.title,
          missing_quantity: expectedQuantity - pickedQuantity,
        };
      })
      .filter((item) => item.missing_quantity > 0);

  const submitPickupConfirmation = async () => {
    if (!pickupConfirmationMeta) {
      return;
    }

    const missingUnits = getMissingPickupItems().reduce(
      (sum, item) => sum + item.missing_quantity,
      0,
    );

    if (missingUnits > 0) {
      setShowMissingConfirm(true);
      return;
    }

    submitPickupConfirmationConfirmed();
  };

  const submitPickupConfirmationConfirmed = async () => {
    setPickupSubmitLoading(true);
    try {
      if (pickupScanV3Enabled) {
        // decision 9 (darkstore-cmo-receiving-db-picking.md §6.3): dark-store
        // CPs use their own sheet, which reports found / not found / damaged
        // per line with per-reason photos, and submits to pick-tp-v3 mode
        // "ITEMS" carrying whatever boxes were scanned before the fallback.
        await pickTpV3(
          buildPickTpItemsPayload({
            meta: pickupConfirmationMeta,
            items: buildItemsFromState(
              pickupConfirmationItems,
              pickTpItemsState,
            ),
            carriedShipments,
          }),
        );
      } else {
        await markTouchpointPickedUpByCpdbV2({
          ...pickupConfirmationMeta,
          items: pickupConfirmationItems.map((item) => ({
            order_item_id: item.order_item_id,
            picked_quantity: item.is_selected ? item.selected_quantity : 0,
            unpicked_quantity:
              item.expected_quantity -
              (item.is_selected ? item.selected_quantity : 0),
          })),
        });
      }
      closePickupConfirmationModal();
      onRefresh();
    } catch (err) {
      // Agra/v2 keeps its original message source untouched; only the new
      // v3 submit path uses the dark-store error-code → Hindi toast map.
      Alert.alert(
        pickupScanV3Enabled
          ? getPickTpErrorMessage(err)
          : err?.response?.data?.message || "Unable to confirm pickup",
      );
    } finally {
      setPickupSubmitLoading(false);
    }
  };

  const onButtonPress = async (key, data, parentItem = null) => {
    try {
      if (key === "MULTIPLE_ORDERS") {
        navigation.navigate("CustomerOrdersView", {
          data,
          type: "delivery",
        });
      } else if (key === "CONFIRM_DELIVERY") {
        return navigation.navigate("PreDeliveryItemList", {
          orders_list: data?.order_ids,
          spoke_name: "",
          date: "",
          user_name: data?.user_name,
          user_id: data?.user_id,
          user_phone: data?.user_phone,
          is_delivery: true,
          afterOtpRedirectScreenName: "MyTask",
        });
      } else if (key === "CANCEL_DELIVERY") {
        return navigation.navigate("PreDeliveryItemList", {
          orders_list: data?.order_ids,
          spoke_name: "",
          date: "",
          user_name: data?.user_name,
          user_id: data?.user_id,
          user_phone: data?.user_phone,
          is_delivery: false,
        });
      } else if (key === "CANCEL_RTO") {
        const payload = {
          return_req_ids: data?.return_req_ids,
        };
        await cancelRto(payload);
        onRefresh();
      } else if (key === "MULTIPLE_RTOS") {
        navigation.navigate("CustomerOrdersView", {
          data,
          type: "rto",
        });
      } else if (key === "CONFIRM_PICKUP") {
        if (pickupConfirmationV2Enabled) {
          await openPickupConfirmationModal(data, parentItem);
          return;
        }
        const payload = {
          route_id: parentItem?.route_id || data.route_id,
          cx_user_id: parentItem?.user_id || data.user_id,
          order_ids:
            data?.order_ids ||
            data?.delivery_pending_order_ids ||
            [data?.order_id].filter(Boolean),
        };
        if (cp_db_id) {
          await markTouchpointPickedUpByCpdb(payload);
        }
        onRefresh();
      } else if (key === "PICK_TP") {
        const orderIds =
          data?.order_ids ||
          data?.delivery_pending_order_ids ||
          [data?.order_id].filter(Boolean);
        const cxUserId = parentItem?.user_id || data?.user_id;
        const routeId = parentItem?.route_id || data?.route_id;

        if (!orderIds.length || !cxUserId) {
          return;
        }

        setPickTpMeta({
          route_id: routeId,
          cx_user_id: cxUserId,
          order_ids: orderIds,
        });
        setCarriedShipments([]);
        setShowPickTpModal(true);
      } else if (key === "RESET_PICKUP") {
        if (cp_db_id) {
          const routeId = parentItem?.route_id || data.route_id;
          const cxUserId = parentItem?.user_id || data.user_id;
          if (pickupConfirmationV2Enabled) {
            const orderIds =
              data?.order_ids ||
              data?.delivery_pending_order_ids ||
              [data?.order_id].filter(Boolean);
            try {
              await unmarkPickupByCpdbV2({
                route_id: routeId,
                cx_user_id: cxUserId,
                order_ids: orderIds,
              });
            } catch (err) {
              const message =
                err?.response?.data?.message || "Unable to unmark pickup";
              Alert.alert(message);
              throw err;
            }
          } else {
            await markTouchpointPickedUpByCpdb({
              route_id: routeId,
              cx_user_id: cxUserId,
              order_ids: [],
            });
          }
        }
        onRefresh();
      }
    } catch {}
  };
  const openMaps = (latitude, longitude) => {
    try {
      Linking.openURL(
        Platform.OS === "ios"
          ? `https://maps.apple.com/maps?daddr=${latitude},${longitude}`
          : `https://maps.google.com/maps?q=loc:${latitude},${longitude}`,
      );
    } catch (error) {
      Alert.alert(t(`${PATH}/mapsAlert`));
      Sentry.captureException(error);
    }
  };
  const onPressCall = async (key, item) => {
    if (!item && key && typeof key === "object") {
      item = key;
      key = "phone";
    }
    setSelectedCard(item);
    setCallModalMode(item.action ? "EDIT" : "DEFAULT");
    try {
      if (!item?.phone_number_2) {
        if (key === "phone") {
          if (item?.user_id && isRescheduledCp.current) {
            if (
              contactAllowedCardTypes.includes(item.card_type) ||
              item?.action
            ) {
              await createCall(
                item?.phone_number_1,
                item?.user_id,
                item?.route_id,
                item?.callmatic_mode,
              );
              return;
            }
            await setItem(
              "CARD_ACTION",
              JSON.stringify({
                cx_id: item?.user_id,
                action: key,
                cx_phone: item?.phone_number_1,
                created_at: new Date(),
              }),
            );
            await createCall(
              item?.phone_number_1,
              item?.user_id,
              item?.route_id,
              item?.callmatic_mode,
            );
          } else {
            await createCall(
              item?.phone_number_1,
              item?.user_id,
              item?.route_id,
              item?.callmatic_mode,
            );
          }
        } else {
          if (item?.user_id && isRescheduledCp.current) {
            if (
              contactAllowedCardTypes.includes(item.card_type) ||
              item?.action
            ) {
              const url = `whatsapp://send?phone=+91${item?.phone_number_1}`;
              Linking.canOpenURL(url).then(await Linking.openURL(url));
              return;
            }
            await setItem(
              "CARD_ACTION",
              JSON.stringify({
                cx_id: item.user_id,
                action: "wa",
                cx_phone: item?.phone_number_1,
                created_at: new Date(),
              }),
            );
            const url = `whatsapp://send?phone=+91${item?.phone_number_1}`;
            Linking.canOpenURL(url).then(await Linking.openURL(url));
          } else {
            const url = `whatsapp://send?phone=+91${item?.phone_number_1}`;
            Linking.canOpenURL(url).then(await Linking.openURL(url));
          }
        }
      } else {
        setContactOption(key);
      }
    } catch (error) {
      console.error("onPressCall: failed to process call action", error);
    }
  };

  const handlePressEditCallOptions = (item) => {
    if (isRescheduledCp.current) {
      setSelectedCard(item);
      setShowCallOptionsModal(true);
      setCallModalMode("EDIT");
    }
  };

  const handlePressItemspopup = (item) => {
    setSelectedCard(item);
    setShowBagsLargeItemsModal(true);
  };

  const onSearchInputChange = debounce((text) => {
    setSearchText(text);
    fetchData({
      searchTerm: text,
      isSearch: text.length > 0,
    });
  }, 800);
  const onPressCrossIcon = () => {
    onSearchInputChange("");
  };
  const onPressSearchIcon = () => {
    setIsSearchEnabled(!isSearchEnabled);
  };
  const goingBackHandler = () => {
    onSearchInputChange("");
    setIsSearchEnabled(false);
  };
  const checkListDataIsEmpty = () => {
    if (isLoading) {
      return false;
    }
    if (listData) {
      return (
        listData?.every((item) => item?.data?.length === 0) &&
        pastListData?.every((item) => item?.data?.length === 0)
      );
    }
    return true;
  };

  const closeFilterModal = () => {
    setSelectedFilter(appliedFilterRef.current);
    setShowFilterModal(false);
  };

  const filterchange = () => {
    appliedFilterRef.current = selectedFilter;
    setShowFilterModal(false);
    fetchData({});
    analytics.trackEvent(MY_TASK_EVENTS.FILTER_APPLIED, {
      filter: JSON.stringify(filterPayload),
    });
  };

  const renderSvg = (type) => {
    switch (type) {
      case "pending":
        return <Pending color="red" />;
      case "escalated":
        return <Pending />;
      case "rescheduled":
        return <Rescheduled />;
      case "delivery":
        return <Delivery />;
      case "rto":
        return <RtoIcon />;
      default:
        return null;
    }
  };

  const onPressTabBtn = (type) => {
    setCurrentPage(type);
    setListData([]);
    setPastListData([]);
  };
  const numberOfFilters = () => {
    let count = 0;
    Object.keys(selectedFilter).forEach((key) => {
      const increment = Array.isArray(selectedFilter[key])
        ? selectedFilter[key].length > 0
        : selectedFilter[key];
      if (increment) count++;
    });
    return count;
  };

  const fetchSectionData = () => {
    return [
      {
        title:
          currentPage === pageEnum.DELIVERY
            ? t(`${PATH}/todays_delivery`)
            : t(`${PATH}/todays_rto`),
        data: listData,
      },
      {
        title:
          currentPage === pageEnum.DELIVERY
            ? t(`${PATH}/past_delivery`)
            : t(`${PATH}/past_rto`),
        data: pastListData,
      },
    ];
  };
  const searchHeight = useRef(new Animated.Value(45)).current;
  const scrollY = useRef(new Animated.Value(0)).current;
  const scrollDirection = useRef(0);
  const lastScrollY = useRef(0);

  const onScroll = Animated.event(
    [{ nativeEvent: { contentOffset: { y: scrollY } } }],
    { useNativeDriver: false },
  );
  useEffect(() => {
    const listener = scrollY.addListener(({ value }) => {
      if (value > lastScrollY.current) {
        scrollDirection.current = 1;
      } else if (value < lastScrollY.current) {
        scrollDirection.current = -1;
      }
      lastScrollY.current = value;
    });

    return () => scrollY.removeListener(listener);
  }, [scrollY]);

  const toggleSearchVisibility = (visible) => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    Animated.parallel([
      Animated.timing(searchHeight, {
        toValue: visible ? 45 : 0,
        duration: 200,
        useNativeDriver: false,
      }),
    ]).start();
  };

  const handleScroll = () => {
    if (
      scrollDirection.current === 1 &&
      searchText.length === 0 &&
      numberOfFilters() === 0
    ) {
      toggleSearchVisibility(false);
    } else if (
      scrollDirection.current === -1 &&
      searchText.length === 0 &&
      numberOfFilters() === 0
    ) {
      toggleSearchVisibility(true);
    }
  };

  // card_id is the server's own stable identity for a card and, since BI-17,
  // carries a `_{trip_id}` suffix — so one customer split across two trips
  // yields two distinct keys. The previous `${user_id}-${index}` keyed on the
  // ARRAY INDEX, which made those two cards indistinguishable to React and
  // re-ordered them badly on refresh. The `||` fallback keeps a backend that
  // does not send card_id on exactly today's behaviour.
  const keyExtractor = (item, index) =>
    item?.card_id || `${item.user_id}-${index}`;

  const renderItem = useCallback(
    ({ item }) => {
      if (item?.pickups) {
        return (
          <PickupCard
            item={item}
            onButtonPress={onButtonPress}
            onPressCall={onPressCall}
            openMaps={openMaps}
            onPickupCardPress={() => {}}
            handlePressEditCallOptions={handlePressEditCallOptions}
          />
        );
      }
      return (
        <DeliveryCard
          item={item}
          onPressCall={onPressCall}
          openMaps={openMaps}
          onPressBtn={onButtonPress}
          isRescheduledCp={isRescheduledCp.current}
          handlePressItemspopup={handlePressItemspopup}
          handlePressEditCallOptions={handlePressEditCallOptions}
          taskActionConfig={taskActionConfig}
          contactOpts={contactOpts}
          addBagsHandler={addBagsHandler}
        />
      );
    },
    [addBagsHandler, contactOpts, onButtonPress, onPressCall, taskActionConfig],
  );

  const renderPageType = (item) => {
    return (
      <TouchableOpacity
        testID="mt-tab-btn"
        onPress={() => onPressTabBtn(item.type)}
        disabled={item.type === currentPage}
        style={[
          styles.typeContainer,
          {
            minWidth: width / (isRescheduledCp.current ? 3.4 : 3) - 15,
            height: 60,
            backgroundColor:
              item.type === currentPage ? colors.black : colors.white,
          },
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {renderSvg(item.type)}
          <Text
            newfont={true}
            variant="body_text_1"
            style={{
              marginLeft: 4,
              color: item.type === currentPage ? colors.white : colors.black,
            }}
          >
            {item?.title}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text
            newfont={true}
            variant="title_16"
            style={{
              marginLeft: 16,
              marginRight: 8,
              color: item.type === currentPage ? colors.white : colors.black,
            }}
          >
            {item.count}
          </Text>
          {item.delayCount > 0 && item?.type === pageEnum.PENDING && (
            <DelayTag delay={`Delay ${item.delayCount}`} />
          )}
        </View>
      </TouchableOpacity>
    );
  };
  return (
    <View style={styles.container}>
      <HeaderWithSearch
        headertitle={
          !isSearchEnabled ? t(`${PATH}/heading`) : t(`SearchOrder/title`)
        }
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        isSearchEnabled={isSearchEnabled}
        isMapEnabled={true}
        mapScreen="OrdersMapView"
        isBrokenCallEnabled={true}
        brokenCallScreen="BrokenCallReport"
        searchPlaceholder={
          filterV2Meta?.searchTermPlaceholder || t(`SearchOrder/placeholder`)
        }
        onPressCrossIcon={onPressCrossIcon}
        goingBackHandler={isSearchEnabled ? goingBackHandler : null}
        onSearchInputChange={onSearchInputChange}
        onPressSearchIcon={onPressSearchIcon}
      />
      {/* Plotline widget removed */}
      <Animated.View style={{ height: searchHeight }}>
        {searchHeight !== 0 && (
          <View
            style={{
              flexDirection: "row",
              paddingTop: 10,
              marginHorizontal: 12,
            }}
          >
            <SearchField
              searchPlaceholder={filterV2Meta?.searchTermPlaceholder}
              searchText={searchText}
              setSearchText={setSearchText}
              onPressCrossIcon={onPressCrossIcon}
              onSearchInputChange={onSearchInputChange}
              testID="mt-search-field"
              hideShadow={false}
              textInputRef={textInputRef}
            />
            <TouchableOpacity
              testID="mt-filter"
              onPress={() => setShowFilterModal(true)}
              activeOpacity={0.7}
              style={styles.filterContainer}
            >
              {numberOfFilters() > 0 && (
                <View style={styles.filterBadge}>
                  <Text
                    variant="caption_1"
                    style={{
                      color: colors.white,
                      fontSize: 13,
                      lineHeight: 18,
                    }}
                  >
                    {numberOfFilters()}
                  </Text>
                </View>
              )}
              <FiltersIcon />
              <Text variant="body_text_3" style={styles.filterText}>
                {filterV2Meta?.title}
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </Animated.View>
      <View
        style={{
          height: 85,
          paddingVertical: 10,
          backgroundColor: colors.primaryBg,
        }}
      >
        <ScrollView
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          style={styles.pagetypeheader}
        >
          {headerData.map(renderPageType)}
          <View style={{ width: 10 }} />
        </ScrollView>
      </View>

      {checkListDataIsEmpty() ? (
        <EmptyList type={currentPage} searchTerm={searchText} />
      ) : (
        <Animated.SectionList
          sections={fetchSectionData()}
          extraData={pickupConfirmationV2Enabled}
          keyboardShouldPersistTaps="handled"
          refreshControl={
            <RefreshControl refreshing={isRefreshing} onRefresh={onRefresh} />
          }
          renderItem={({ item, index }) => (
            <View key={keyExtractor(item, index)}>
              {renderItem({ item, index })}
            </View>
          )}
          renderSectionHeader={({ section: { title, data } }) =>
            ![
              pageEnum.PENDING,
              pageEnum.ESCALATED,
              pageEnum.RESCHEDULED,
            ].includes(currentPage) &&
            data?.length > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginHorizontal: 16,
                }}
              >
                <Text
                  newfont={true}
                  variant="title_16"
                  style={{ marginVertical: 8, marginRight: 10 }}
                >
                  {title}
                </Text>
                <View
                  style={{
                    flex: 1,
                    height: 0.5,
                    backgroundColor: colors.lightMediumBlack,
                  }}
                />
              </View>
            )
          }
          keyExtractor={(item, index) => keyExtractor(item, index)}
          renderSectionFooter={() => <View style={{ height: 40 }} />}
          onScroll={onScroll}
          onScrollEndDrag={handleScroll}
        />
      )}
      {currentPage === pageEnum.DELIVERY && amountCollected > 0 && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            position: "absolute",
            bottom: 0,
            backgroundColor: colors.plain_green,
            width: "100%",
          }}
        >
          <Text
            variant="subtitle_16"
            style={{ color: colors.white, margin: 10, marginLeft: 16 }}
          >
            {t(`${PATH}/amountCollected`)}
          </Text>

          <Text
            variant="heading_24"
            style={{ color: colors.white, margin: 8, marginRight: 16 }}
          >
            ₹ {amountCollected}
          </Text>
        </View>
      )}
      <BagsItemsModal
        selectedCard={selectedCard}
        showBagsLargeItemsModal={showBagsLargeItemsModal}
        setShowBagsLargeItemsModal={setShowBagsLargeItemsModal}
      />
      <ContactModal
        contactOption={contactOption}
        setContactOption={setContactOption}
        selectedMarker={selectedCard}
        isRescheduledCp={isRescheduledCp.current}
        storageKey="CARD_ACTION"
        createCall={createCall}
      />
      <CallOptionsModal
        selectedMarker={selectedCard}
        visible={isRescheduledCp.current && showCallOptionsModal}
        callModalMode={callModalMode}
        onClose={() => setShowCallOptionsModal(false)}
        setShowCallOptionsModal={setShowCallOptionsModal}
        setContactOption={setContactOption}
        refreshData={fetchData}
        taskActionConfig={taskActionConfig}
      />
      <FilterModal
        visible={showFilterModal}
        // Closing without Save (✕, backdrop, Android back) discards the draft.
        onClose={closeFilterModal}
        onSave={filterchange}
        filterData={filterV2}
        currentFilter={selectedFilter}
        handleOptionPress={handleOptionPress}
        getSelectedFilters={getSelectedFilters}
        clearFilters={clearFilters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        metadata={filterV2Meta}
      />
      <Modal
        visible={isLoading}
        transparent={true}
        statusBarTranslucent
        navigationBarTranslucent
      >
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      </Modal>
      <SarvCallModal
        showSarvModal={showSarvModal}
        setShowSarvModal={setShowSarvModal}
      />
      {/* Dark-store CPs get the outcome+quantity sheet (decision 9); every
          other CP keeps Agra's untouched qty-only sheet and its missing-items
          confirm step. */}
      {pickupScanV3Enabled ? (
        <PickTpItemsModal
          visible={showPickupConfirmationModal}
          items={pickupConfirmationItems}
          isLoading={pickupItemsLoading}
          isSubmitting={pickupSubmitLoading}
          state={pickTpItemsState}
          onStateChange={setPickTpItemsState}
          onClose={closePickupConfirmationModal}
          onSubmit={submitPickupConfirmationConfirmed}
        />
      ) : (
        <>
          <PickupConfirmationModal
            visible={showPickupConfirmationModal}
            items={pickupConfirmationItems}
            isLoading={pickupItemsLoading}
            isSubmitting={pickupSubmitLoading}
            onClose={closePickupConfirmationModal}
            onSubmit={submitPickupConfirmation}
            onQuantityChange={onPickupQuantityChange}
            onSelectionChange={onPickupSelectionChange}
          />
          <MissingItemsConfirmModal
            visible={showMissingConfirm}
            missingUnits={getMissingPickupItems().reduce(
              (sum, item) => sum + item.missing_quantity,
              0,
            )}
            missingItems={getMissingPickupItems()}
            isSubmitting={pickupSubmitLoading}
            onCancel={() => setShowMissingConfirm(false)}
            onConfirm={submitPickupConfirmationConfirmed}
          />
        </>
      )}
      <PickTpShipmentsModal
        visible={showPickTpModal}
        meta={pickTpMeta}
        onClose={closePickTpModal}
        onSubmitSuccess={handlePickTpSubmitSuccess}
        onFallbackToItems={handlePickTpFallback}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: colors.primaryBg },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },

  typeContainer: {
    borderRadius: 8,
    paddingVertical: 6,
    paddingHorizontal: 6,
    alignItems: "flex-start",
    elevation: 4,
    marginTop: 2,
    marginLeft: 10,
    backgroundColor: colors.white,
  },
  pagetypeheader: {
    height: 60,
  },
  filterContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2FBF7",
    borderRadius: 18,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginRight: 4,
    borderColor: "#CCDFD6",
    borderWidth: 1,
  },
  filterText: {
    marginLeft: 4,
  },
  filterBadge: {
    backgroundColor: "#4274EA",
    padding: 2,
    borderRadius: 20,
    position: "absolute",
    top: -8,
    right: -8,
    minWidth: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default MyTask;
